import { StepNavigationSwitch } from '../../atoms/step-navigation-switch';
import { PreviewGenericNavigation } from './navigation/preview-generic-navigation';
import { PreviewBody } from './preview-body';

export const PreviewNavigationSwitch = () => {
  return <StepNavigationSwitch body={PreviewBody} generic={PreviewGenericNavigation} />;
};
